import { render } from "./TreeViewBasicPreview.vue?vue&type=template&id=5967b88e"
import script from "./TreeViewBasicPreview.vue?vue&type=script&lang=js"
export * from "./TreeViewBasicPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__